// extracted by mini-css-extract-plugin
export default {"ringLoader":"Loader_ringLoader__TVUhn","loadMore":"Loader_loadMore__tnn4X"};